import { render, staticRenderFns } from "./Template101.vue?vue&type=template&id=40f5ead1&scoped=true&"
import script from "./Template101.vue?vue&type=script&lang=js&"
export * from "./Template101.vue?vue&type=script&lang=js&"
import style0 from "./Template101.vue?vue&type=style&index=0&id=40f5ead1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5ead1",
  null
  
)

export default component.exports